// extracted by mini-css-extract-plugin
export default {"list":"Navigation_list__AAMWN","link":"Navigation_link__OWMsq","activeLink":"Navigation_activeLink__lEs2v"};